import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from "@angular/common/http";
import * as GarageModels from "../../models/garage/garage";
import { EnvironmentService } from "../../../app/services/environment.service";
import { GarageSearchModel } from "../../models/garage/garageSearch";
import { HelperService } from "../helper/helper.service";
import * as Models from "../../models/commonModels";

@Injectable({
  providedIn: "root",
})
export class GarageService {
  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private helperService: HelperService
  ) { }

  public getDictionary(Search: GarageSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageModels.GarageDictionaryListModel>(
      `${this.environmentService.getApiURL()}/garage/dictionary`,
      Search,
      options
    );
  }

  public getList(Search: GarageSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<GarageModels.GarageListModel>(
      `${this.environmentService.getApiURL()}/garage/list`,
      Search,
      options
    );
  }

  public set(Garage: Models.Request<GarageModels.GarageModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GarageModel>>(
      `${this.environmentService.getApiURL()}/garage/set`,
      Garage,
      options
    );
  }

  public create(Garage: Models.Request<GarageModels.GarageModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GarageModel>>(
      `${this.environmentService.getApiURL()}/garage/create`,
      Garage,
      options
    );
  }

  public get(Garage: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GarageModel>>(
      `${this.environmentService.getApiURL()}/garage/get`,
      Garage,
      options
    );
  }

  public sendEmail(Email: GarageModels.GarageGroupEmailModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post(
      `${this.environmentService.getApiURL()}/garage/groupemail/send`,
      Email,
      options
    );
  }

  public sendMessage(Message: GarageModels.GarageGroupMessageModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    return this.httpClient.post(
      `${this.environmentService.getApiURL()}/garage/groupmessage/send`,
      Message,
      options
    );
  }

  public getGroupMessages() {
    return this.httpClient.get<GarageModels.GarageGroupMessagesListModel>(
      `${this.environmentService.getApiURL()}/garage/garage/groupmessage/get/all`
    );
  }

  public getLastGroupMessage() {
    return this.httpClient.get<GarageModels.GarageGroupMesageObjectModel>(
      `${this.environmentService.getApiURL()}/garage/groupmessage/get/last`
    );
  }

  public getReport(search: GarageSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environmentService.getApiURL()}/garage/report/filtered`,
      search,
      options
    );
  }

  public getReportWithDeposites(search: GarageSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environmentService.getApiURL()}/garage/report/filtered-deposites`,
      search,
      options
    );
  }

  public getLocations(Search: GarageSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<GarageModels.GarageLocationListModel>(
      `${this.environmentService.getApiURL()}/garage/list/location`,
      Search,
      options
    );
  }

  public getCustomerReport(search: GarageSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environmentService.getApiURL()}/garage/report/filtered-customer`,
      search,
      options
    );
  }


  public getGarageDiscount(Garage: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GarageDiscountPreviewModel[]>>(
      `${this.environmentService.getApiURL()}/garage/get/discount`,
      Garage,
      options
    );
  }

  
  public getGarageDiscountTemplate(Garage: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GarageDiscountPreviewModel[]>>(
      `${this.environmentService.getApiURL()}/garage/get/discount/template`,
      Garage,
      options
    );
  }

  public setGarageDiscount(Garage: Models.Request<GarageModels.SetGarageDiscountPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GarageDiscountPreviewModel[]>>(
      `${this.environmentService.getApiURL()}/garage/set/discount`,
      Garage,
      options
    );
  }

  public getGarageDiscountExcelReport(search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    
    return this.httpClient.post<Blob>(
      `${this.environmentService.getApiURL()}/garage/discount/report-excel`,
      search,
      options
    );
  }

  public importGarageDiscount(Data: any) { 
    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/garage/discount/import`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public setCommission(Message: GarageModels.GarageSetComissionModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    return this.httpClient.post(
      `${this.environmentService.getApiURL()}/garage/set-commision`,
      Message,
      options
    );
  }
}
